<template>
  <v-col cols="12" md="7" :lg="setColAspect()" id="search_prd" class="pa-0 ma-0 grey lighten-4"
    :class="is_mobile ? 'cart_mobile' : ''">
    <v-row class="pa-0 ma-0 pr-lg-0 pr-2 grey lighten-4" :class="{ 'buscador-fijo': topFijo !== null }"
      :style="topFijo !== null ? { top: topFijo + 'px' } : null">
      <v-col cols="12">
        <ng-text-keyboard :filled="false" outlined rounded :dense="setDense()" :placeholder="$t('placeholder_search_products')"
          prepend-inner-icon="mdi-magnify" autofocus v-model="query" @click:clear="clear()" @click:prepend-inner="enterEvent"
          @keyup.enter="enterEvent" hide-details :nudgetTop="0" :readOnly="false" :inputmode="$store.getters.mobile ? 'text' : 'none'"
          background-color="white"></ng-text-keyboard>
      </v-col>
      <!-- @input="search" -->
      <!-- <v-col cols="12" sm="8" md="8" lg="8">
        <ng-text-keyboard :filled="false" :dense="setDense()" :placeholder="$t('Código de barras')"
          append-icon="mdi-magnify" autofocus v-model="query" @keyup.enter="searchByCodeBar" hide-details :nudgetTop="0"
          :readOnly="false" inputmode='none' background-color="white"></ng-text-keyboard>
      </v-col> -->

      <v-col cols="12" class="pt-0 pb-1">
        <div class="fila-filtros">
          <div class="chips-categorias" :class="{ 'chips-categorias--ancho': !lista }">
            <v-chip small :color="breadcrumbs.length ? undefined : 'primary'" :outlined="breadcrumbs.length > 0"
              @click="removeFilterCategory('INICIO')">Todas</v-chip>
            <v-chip small v-for="(bc, i) in breadcrumbs" :key="'bc' + bc.id"
              :color="i === breadcrumbs.length - 1 ? 'primary' : undefined" :outlined="i !== breadcrumbs.length - 1"
              @click="removeFilterCategory(bc)">{{ bc.text }}</v-chip>
            <v-chip small outlined v-for="cat in categoriasVisibles" :key="cat.id" @click="navigateByCategory(cat)">
              {{ cat.name }}<v-icon x-small right v-if="cat.children && cat.children.length">mdi-chevron-right</v-icon>
            </v-chip>
            <v-chip small outlined color="primary" v-if="hayMasCategorias" @click="verMasCategorias = !verMasCategorias">
              {{ verMasCategorias ? "Ver menos" : "+" + (visibleCategories.length - limitCategories) + " más" }}
            </v-chip>
          </div>
          <v-chip small outlined color="primary" class="chip-avanzada" v-if="$store.getters.isDrugStore" @click="toggleAvanceSearch">
            <v-icon x-small left>mdi-text-box-search-outline</v-icon>Avanzada
          </v-chip>
        </div>
      </v-col>
    </v-row>

    <v-divider />

    <v-row no-gutters class="px-5" v-if="!lista">

      <v-col cols="12" class="pt-2">
        <v-row no-gutters :key="key" v-if="!is_mobile">
          <v-col cols="12" sm="12" md="6" lg="4" xl="3" class="pa-0 ma-0 mt-3" v-for="(product, index) in products"
            :key="index" :class="{ 'product-without-price': !product.price }">
            <ProductCard :item="product" @select:product="emitProductSelected" @select:product-batch="emitProductBatchSelected" :priceList="priceList" />
          </v-col>
          <v-col cols="12" class="text-center my-5" v-if="hayMas"><v-btn outlined block color="primary" @click="loadMore"><v-icon
                left>mdi-reload</v-icon> {{ $t("load_more") }}</v-btn></v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row no-gutters class="prd_cart_mobile pa-2" :style="getHeight()" :key="key" v-else>
      <v-col cols="12">
        <v-list three-line>
          <template v-for="(product, index) in products">
            <ProductCardMobile :item="product" @select:product="emitProductSelected" @select:product-batch="emitProductBatchSelected" :key="index"
              :priceList="priceList" />
            <v-divider :key="product.id"></v-divider>
          </template>
        </v-list>
        <div v-if="products.length === 0" class="text-center grey--text py-8">
          <v-icon large color="grey lighten-1">mdi-magnify-close</v-icon>
          <div class="mt-2">No encontramos productos</div>
          <div class="caption">Revisa lo que escribiste o quita la categoría.</div>
        </div>
        <v-btn v-if="hayMas" outlined block color="primary"
          class="my-3" @click="loadMore"><v-icon left>mdi-reload</v-icon> {{ $t("load_more") }}</v-btn>
      </v-col>
    </v-row>


    <SearchMedications v-if="showAdvanceSearch" :priceList="priceList" @close="closeAdvanceSearch"></SearchMedications>
       
  </v-col>
</template>
<script>
import ProductCard from "./ProductCard";
import ProductCardMobile from "./ProductCardMobile";
import { esAgotado } from "@/plugins/pos/agotados";
import { patronSinTildes } from "@/plugins/pos/sin-tildes";
import SearchMedications from "./SearchMedications";

export default {
  name: "SearchProducts",
  components: { ProductCard, ProductCardMobile, SearchMedications },
  props: ["is_mobile", "aspect_ratio", "priceList", "modoLista"],
  data: () => ({
    showCategories: false,
    verMasCategorias: false,
    breadcrumbs: [],
    categoryItems: [],
    currentCategory: null,
    openInstall: false,
    installed: false,
    key: 0,
    query: "",
    products: [],
    page: 0,
    limitCategories: 7,
    showAdvanceSearch: false,
    hayMas: true,
    filtroActual: {},
    limiteActual: 20,
    topFijo: null,
    esperaBusqueda: null,
    // Un lector escribe todo el código en milisegundos; una persona deja pausas entre teclas.
    escritoAMano: false,
    ultimaTecla: 0
    //priceList:
  }),

  async mounted() {
    //await this.$db.load();
    this.updateProducts();

    this.categoryItems = await this.$db.getAllCategories();
    this.fijarBuscador();
    document.addEventListener("keydown", this.teclaGlobal);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.teclaGlobal);
    clearTimeout(this.esperaBusqueda);
  },
  /* beforeUpdate(){
     this.search();
   },*/
  watch: {
    keyReload() {
      this.search();
    },
    // Busca mientras se escribe (con una pequeña espera); Enter sigue buscando por código de barras.
    query(nuevo) {
      if (!nuevo) {
        this.escritoAMano = false;
      }
      clearTimeout(this.esperaBusqueda);
      this.esperaBusqueda = setTimeout(() => this.buscarEnVivo(), 300);
    },
  },
  computed: {
    // Lista de filas con chips de categorías (celular, y la app de meseros en cualquier tamaño) o la cuadrícula de tarjetas.
    lista() {
      return !!this.$store.getters.mobile || !!this.modoLista;
    },
    // En computador, las primeras categorías y un «+N más»; en celular se desplazan todas de lado.
    categoriasVisibles() {
      if (this.lista || this.verMasCategorias) return this.visibleCategories;
      return this.visibleCategories.slice(0, this.limitCategories);
    },
    hayMasCategorias() {
      return !this.lista && this.visibleCategories.length > this.limitCategories;
    },
    visibleCategories() {
      if (this.currentCategory) {
        return this.currentCategory.children;
      } else {
        return this.categoryItems;
      }
    },
  },
  methods: {
    closeAdvanceSearch(item){
      this.showAdvanceSearch = false;
      if(item){
        if(item.has_batch){
          this.emitProductBatchSelected(item)
        } else{
          this.emitProductSelected(item)
        } 
      }
    },
    showButtonCategories(){
      if(this.visibleCategories.length > this.limitCategories){
        return true;
      }
      return false;
    },
    toggleAvanceSearch(){
      this.showAdvanceSearch = !this.showAdvanceSearch; 
    },
    toggleCategories() {
      this.showCategories = !this.showCategories; // Cambia el estado de visibilidad
    },
    removeFiltersAndNavigateTo(bc) {
      let index = this.breadcrumbs.findIndex(
        (elemento) => elemento.text === bc.text
      );

      if (index + 1 == this.breadcrumbs.length) {
        return;
      }
      this.breadcrumbs.splice(index + 1);
      let idx = this.categoryItems.findIndex(
        (elemento) => elemento.name === bc.text
      );
      this.currentCategory = this.categoryItems[idx];
      this.filterByCategory(this.idsDeCategoria(this.currentCategory));
    },
    removeFilterCategory(bc) {
      if(bc == 'INICIO'){
        this.currentCategory = null;
        this.breadcrumbs = [];
        this.updateProducts({});
      }else{
        let index = this.breadcrumbs.findIndex(
          (elemento) => elemento.text === bc.text
        );
        if (index === -1) {
          index = 0;
        }
        
        if (index >= 0) {
          let totalDeleteBreadCrumbs = this.breadcrumbs.length - ( index + 1);
          this.breadcrumbs.splice(index+1, totalDeleteBreadCrumbs);
          let before = this.breadcrumbs[index];
          let idx = this.categoryItems.findIndex(
            (elemento) => elemento.name === before.text
          );
          this.currentCategory = before.cat || this.categoryItems[idx];
          this.filterByCategory(this.idsDeCategoria(this.currentCategory));
        }

      }
      


      /*
      this.breadcrumbs.splice(index);

      if (index == 0) {
        this.currentCategory = null;
      } else {
        let before = this.breadcrumbs[index - 1];
        let idx = this.categoryItems.findIndex(
          (elemento) => elemento.name === before.text
        );

        this.currentCategory = this.categoryItems[idx];
        this.filterByCategory([this.currentCategory.id]);

      }*/
      //this.filterByCategory([this.currentCategory.id])
    },
    navigateByCategory(cat) {
      this.breadcrumbs.push({ id: cat.id, text: cat.name, disabled: false, href: "#", cat: cat });
      this.currentCategory = cat;
      this.setLastBreadCrumbDisabled();
      this.filterByCategory(this.idsDeCategoria(cat));
    },
    // La categoría y todas sus subcategorías: al pulsar «Bebidas» salen también las gaseosas
    // y los jugos, no sólo lo que está directamente en «Bebidas».
    idsDeCategoria(cat) {
      const ids = [cat.id];
      for (const hija of cat.children || []) {
        ids.push(...this.idsDeCategoria(hija));
      }
      return ids;
    },
    filterByCategory(cats) {
      let params = {
        $or: [{ category_id: { $in: cats } }],
      };
      if (cats.length == 0) {
        params = {};
      }
      this.updateProducts(params,10000);
      this.page = 0;
      this.hayMas = false;
    },
    // Un producto agotado no se agrega: se avisa y la orden queda como estaba.
    avisarAgotado(pr) {
      if (!esAgotado(pr && pr.id)) return false;
      this.$store.commit("setMessage", "Se agotó: " + pr.name);
      return true;
    },
    emitProductSelected(pr) {
      if (this.avisarAgotado(pr)) return;
      this.$emit("select:product", pr);
      this.enfocar();
    },
    emitProductBatchSelected(pr) {
      if (this.avisarAgotado(pr)) return;
      this.$emit("select:product-batch", pr);
      this.enfocar();
    },
    setLastBreadCrumbDisabled(){
      if (this.breadcrumbs.length > 0) {
        this.breadcrumbs.forEach((item, index, array) => {
          if (index === array.length - 1) {
            item.disabled = true; 
          } else{
            item.disabled = false; 
          }
        });
      }
    },
    async enterEvent() {
      await this.search();
      // Solo lo escrito a mano agrega el único resultado; un código del lector que no existe exacto no debe
      // agregar otro producto que lo contenga.
      if (this.query && this.escritoAMano && this.products.length === 1) {
        const unico = this.products[0];
        this.query = "";
        this.emitirProducto(unico);
        this.enfocar();
      }
    },
    clear() {
      this.query = "";
      this.search();
    },
    // En la app de meseros el buscador y las categorías se quedan fijos debajo de las barras de arriba.
    fijarBuscador() {
      if (!this.modoLista) {
        return;
      }
      // En la pantalla ancha la lista se desplaza dentro de su propio panel: el buscador se pega arriba de él.
      if (!this.$store.getters.mobile) {
        this.topFijo = 0;
        return;
      }
      const barra = document.querySelector(".fixed-bar");
      if (barra) {
        const contenido = barra.querySelector(".v-toolbar__content") || barra;
        this.topFijo = Math.round(contenido.getBoundingClientRect().bottom);
      }
    },
    buscarEnVivo() {
      if (!this.query) {
        this.page = 0;
        this.hayMas = true;
        this.updateProducts({});
        return;
      }
      // Al buscar se deja la categoría: el resultado sale de todo el catálogo.
      this.currentCategory = null;
      this.breadcrumbs = [];
      try {
        // Lo escrito se busca tal cual (un paréntesis no rompe la búsqueda) y sin importar las tildes.
        const q = patronSinTildes(this.query);
        const condiciones = [
          { name: { $regex: [q, "i"] } },
          { reference: { $regex: [q, "i"] } },
          { bar_code: { $regex: [q, "i"] } },
        ];
        // En una droguería también se busca por principio activo: «algo con acetaminofén».
        if (this.$store.getters.isDrugStore) {
          condiciones.push({ "info_medication.active_ingredient": { $regex: [q, "i"] } });
        }
        this.updateProducts({ $or: condiciones }, 60);
      } catch (e) {
        this.products = [];
      }
    },
    async search() {
      if (await this.searchByCodeBar()) {
        return;
      }
      const q = patronSinTildes(this.query);
      const params = {
        $or: [
          { name: { $regex: [q, "i"] } },
          //{'category': { '$regex': [this.query, 'i'] }},
          { reference: { $regex: [q, "i"] } },
          { bar_code: { $regex: [q, "i"] } },
        ],
      };
      this.updateProducts(params, 60);
    },
    emitirProducto(p) {
      this.$emit(p.has_batch ? "select:product-batch" : "select:product", p);
    },
    // Deja el cursor en el buscador para seguir pasando productos por el lector sin tocar la pantalla.
    // Si el producto abrió una ventana (opciones, lote, peso) no se le quita el foco.
    enfocar() {
      setTimeout(() => {
        if (document.querySelector(".v-dialog--active, .v-menu__content--active")) {
          return;
        }
        const campo = this.$el && this.$el.querySelector("input");
        if (campo && document.activeElement !== campo) {
          campo.focus();
        }
      }, 120);
    },
    // El lector de barras «teclea» el código: si el cursor no está en ningún campo, lo que se escriba va al buscador.
    teclaGlobal(e) {
      if (e.key && e.key.length === 1) {
        const ahora = Date.now();
        if (this.query && ahora - this.ultimaTecla > 80) {
          this.escritoAMano = true;
        }
        this.ultimaTecla = ahora;
      }
      if (e.ctrlKey || e.metaKey || e.altKey || !e.key || e.key.length !== 1 || this.$store.getters.mobile) {
        return;
      }
      const t = e.target;
      if (t && (/^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName) || t.isContentEditable)) {
        return;
      }
      if (document.querySelector(".v-dialog--active")) {
        return;
      }
      const campo = this.$el && this.$el.querySelector("input");
      if (campo) {
        campo.focus();
      }
    },
    async searchByCodeBar() {
      // El lector puede dejar espacios al principio o al final del código.
      this.query = (this.query || "").trim();
      let params = {
        $or: [
          { reference: { $eq: this.query } },
          { bar_code: { $eq: this.query } },
        ],
      };
      if (!this.query) {
        return false;
      }
      let products = this.$db.searchProductByCodeBarOrReference(params, 1);
      if (products && products.length == 1) {
        if(products[0].has_batch){
          this.$emit("select:product-batch", products[0]);
        } else{
          this.$emit("select:product", products[0]);
        }
        this.query = "";
        this.enfocar();
        return true;
      } else {
        params = {
          $or: [
            { reference: { $eq: this.query } },
            { bar_code: { $eq: this.query } },
          ],
        };
        let productVariants = this.$db.searchProductVariantByCodeBarOrReference(
          params,
          1
        );
        if (productVariants && productVariants.length == 1) {
          this.$emit("select:product-variant", productVariants[0]);
          this.query = "";
          this.enfocar();
          return true;
        }
      }
      return false;
    },
    /*installedEvent(){
     this.installed = true;
     this.updateProducts();
    },*/
    // Recuerda el filtro (búsqueda o categoría) y cuántos trae: «Cargar más» pide más de ese mismo filtro.
    // Una categoría trae todo (10000), por eso ahí no hay nada más que cargar.
    updateProducts(params,limit = 20) {
      this.filtroActual = params;
      this.limiteActual = limit;
      this.products = this.$db.searchProducts(params, limit, "name");
      this.hayMas = limit < 10000 && this.products.length >= limit;
    },
    loadMore() {
      const paso = this.query ? 60 : 20;
      this.updateProducts(this.filtroActual, this.limiteActual + paso);
    },
    handleButtonClick(item) {
      this.removeFilterCategory(item);
      // this.loadMore();
    },
    setDense() {
      if (this.is_mobile) {
        return true;
      }
      return false;
    },
    getHeight() {
      let vHeight = 87;
      if (this.is_mobile || this.modoLista) {
        return "";
      } else {
        if (this.aspect_ratio) {
          if (this.aspect_ratio.screen_height) {
            if (this.aspect_ratio.screen_height == 768) {
              vHeight -= 5;
            }
            if (this.aspect_ratio.screen_height == 800) {
              vHeight -= 4;
            }
            if (this.aspect_ratio.screen_height == 900) {
              vHeight -= 2;
            }
            if (this.aspect_ratio.screen_height == 1024) {
              vHeight -= 3;
            }
          }
        }
      }
      return "height: " + vHeight + "vh; overflow-y:auto;";
    },
    setColAspect() {
      const aspect = ["5:4", "4:3", "16:9", "16:10"];
      if (this.aspect_ratio) {
        if (this.aspect_ratio.aspect_ratio) {
          if (this.inArray(this.aspect_ratio.aspect_ratio, aspect)) {
            return 7;
          }
        }
      }
      return 8;
    },
    inArray(needle, haystack) {
      var length = haystack.length;
      for (var i = 0; i < length; i++) {
        if (haystack[i] == needle) return true;
      }
      return false;
    },
  },
};
</script>
<style>
@media (min-width: 700px) {
  .app-meseros .prd_cart_mobile .v-list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 12px;
  }

  .app-meseros .prd_cart_mobile .v-list .v-divider {
    display: none;
  }

  .app-meseros .prd_cart_mobile .producto-movil {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  }
}

.buscador-fijo {
  position: sticky;
  top: 0;
  z-index: 1;
}

.fila-filtros {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.fila-filtros .chips-categorias {
  flex: 1 1 auto;
  min-width: 0;
}

.chip-avanzada {
  flex: 0 0 auto;
}

/* En computador las fichas pasan a otra línea en vez de desplazarse de lado. */
.chips-categorias--ancho {
  flex-wrap: wrap;
  overflow: visible;
  white-space: normal;
}

.chips-categorias {
  display: flex;
  gap: 6px;
  overflow-x: auto;
  white-space: nowrap;
  padding-bottom: 2px;
  scrollbar-width: none;
}

.chips-categorias::-webkit-scrollbar {
  display: none;
}

.chips-categorias .v-chip {
  flex: 0 0 auto;
}

#search_prd {
  overflow-y: scroll;
  height: 94vh;
}

.truncated-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.product-without-price {
  border-radius: 4px;
  background: var(--v-error-lighten2) !important;
}

.ctg_qty {
  position: absolute;
  top: 0;
  right: 0;
  margin: -10px;
  z-index: 1;
  outline: 2px solid #24a9e1;
}

.glass {
  border-top: 1px solid rgba(255, 255, 255, 0.3);
  background: rgba(36, 169, 225, 0.75);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}
</style>